import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaMeta'

type IcaMetaProps = React.JSX.IntrinsicElements['tgdb-ica-meta']

export const IcaMeta = wrapWc<IcaMetaProps>('tgdb-ica-meta', [])